import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/recruitment/candidates_/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/recruitment/candidates/$id/profile',
      params: { id: params.id },
      replace: true,
    });
  },
});
